import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string, search: string): SafeHtml {
    if (!search) {
      return text;
    }
    const re = new RegExp(search, 'gi');
    const match = text.match(re);
    if (!match) {
      return text;
    }
    const highlighted = text.replace(re, `<span class="highlight">${match[0]}</span>`);
    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }
}
